module.exports = __webpack_public_path__ + "static/p1.61064097.jpg";